import { ApiProperty } from '@nestjs/swagger'
import { OffsetPaginationResponseDto } from '@sphere/shared/domain'
import { AttemptEntity } from './attempt.response'

export class AttemptListOffsetResponseDto extends OffsetPaginationResponseDto<AttemptEntity> {
  @ApiProperty({ type: () => AttemptEntity, isArray: true })
  declare data: AttemptEntity[]
}
